/* eslint-disable */
import { catFetchGet } from './base/catFetchClient';

export type CatWeek = {
    id: number,
    week: number,
    firstDay: Date,
    lastDay: Date,
    monthYearId: number,
    firstDayStr: string,
    lastDayStr: string,
    locked: boolean,
    percentLoggedInSum: number
}

export const getWeeksAsync = async (page: number) => {
    return await catFetchGet(`week/getweeks?page=${page}`);
}